<template>
  <a-modal
    destroyOnClose
    :footer="null"
    :maskClosable="false"
    centered
    :title="title"
    v-model="visible"
    width="60%">
    <template v-if="selectedRows.length > 0">
      <vxe-button icon="vxe-icon-square-close-fill" mode="text" size="mini" status="primary" @click="closeTag()"></vxe-button>
      <template v-for="row in selectedRows">
        <a-tooltip v-if="row.name.length > 10" :key="row.id" :title="row.name">
          <a-tag :key="row.id" :closable="true" @close="() => closeTag(row)" color="blue">
            {{ `${row.name.slice(0, 10)}...` }}
          </a-tag>
        </a-tooltip>
        <a-tag v-else :key="row.id" :closable="true" @close="() => closeTag(row)" color="blue">
          {{ row.name }}
        </a-tag>
      </template>
      <a-divider />
    </template>
    <a-space>
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.no')"
        v-model="query['no']"
      />
      <a-input-search
        @pressEnter="search"
        @search="search"
        :placeholder="$t('business.label.name')"
        v-model="query['name']"
      />
      <vxe-button content="button.confirm" size="mini" status="primary" @click="confirm"/>
      <vxe-button content="button.cancel" size="mini" status="info" @click="cancel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true ,useKey:true, keyField: 'id'}"
      :column-config="{resizable: true}"
      :radio-config="{trigger: 'row'}"
      :checkbox-config="{trigger: 'row'}"
      style="margin-top: 2px"
      @checkbox-all="({checked})=>checkAll(checked)"
      @checkbox-change="({checked, row})=>changeCheckbox(checked, row)"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column :type="selectType" fixed="left" width="50" />
      <vxe-column field="no" title="business.label.storerNo" width="80" />
      <vxe-column field="name" title="business.label.storerName" width="120"/>
      <vxe-column field="mnemonicCode" title="business.label.mnemonicCode" />
      <vxe-column field="dataSource" title="business.label.dataSource">
        <template #default="{ row }">{{ convert(row.dataSource, dataSourceData, 'ordinal', 'name') }}</template>
      </vxe-column>
      <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="available" title="business.label.available" width="70"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-modal>
</template>
<script>
import Vue from 'vue'
import { findAll, findEnum } from '@/api/Api'
import { convert } from '@/utils/util'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'StorerModal',
    data() {
      return {
        show: true,
        size: 15,
        page: 1,
        contentSize: 0,
        visible: false,
        loading: false,
        data: [],
        query: { no: '', name: '' },
        args: null,
        selectedRows: [],
        dataSourceData: [],
        record: undefined,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.5)// 表格竖向滚动条
      }
    },
    props: {
      selectType: {
        type: String,
        default: 'radio'
      },
      title: {
        type: String,
        default: '货主检索'
      }
    },
    methods: {
      convert,
      init(args) {
        this.query = { no: '', name: '' }
        this.data = []
        this.selectedRows = []
        this.page = 1
        if (args) {
          this.args = args
          Object.assign(this.query, args)
        }
      },
      open(args, e, selectedRows) {
        this.init(args)
        this.record = e
        if (this.selectType === 'checkbox' && selectedRows && selectedRows.length > 0) {
          this.selectedRows = JSON.parse(JSON.stringify(selectedRows))
        }
        this.visible = true
        this.loading = true
        setTimeout(() => {
          this.loadingPreData()
        }, 300)
      },
      pageChange({ currentPage, pageSize }) {
        this.page = currentPage
        this.size = pageSize
        this.getData()
      },
      getData() {
        this.loading = true
        findAll('storerFactory', this.query, this.page, this.size).then((res) => {
          if (res.success) {
            this.data = res.result
            this.contentSize = res.contentSize
            if (this.selectedRows.length > 0) {
              this.$refs.table.setCheckboxRow(this.selectedRows, true)
            }
          }
        }).finally(() => this.loading = false)
      },
      loadingPreData() {
        let promiseArr = []
        if (this.dataSourceData.length === 0) {
          promiseArr.push(new Promise(resolve => {
            findEnum('DataSource').then(res => {
              if (res.success) {
                this.dataSourceData = res.result
              }
            }).finally(() => resolve())
          }))
        }
        Promise.all(promiseArr).then(() => this.getData())
      },
      search() {
        this.page = 1
        this.getData()
      },
      dblclick() {
        if (this.selectType === 'radio') {
          this.confirm()
        }
      },
      confirm() {
        let selectedRows
        if (this.selectType === 'radio') {
          let radioRow = this.$refs.table.getRadioRecord()
          if (radioRow !== null) {
            selectedRows = [radioRow]
          } else {
            selectedRows = []
          }
        } else {
          if (this.selectedRows.length > 0) {
            selectedRows = this.selectedRows
          } else {
            selectedRows = this.$refs.table.getCheckboxRecords()
          }
        }
        this.$emit('change', selectedRows, this.record)
        this.visible = false
      },
      cancel() {
        this.visible = false
      },
      closeTag(row) {
        if (row) {
          this.$refs.table.setCheckboxRow(row, false)
        } else {
          this.$refs.table.clearCheckboxRow()
        }
        this.removeSelectedRow(row)
      },
      addTag(row) {
        if (this.selectedRows.findIndex(item => item.id === row.id) === -1) {
          this.selectedRows.push(row)
        }
      },
      removeSelectedRow(row) {
        if (row) {
          this.selectedRows = this.selectedRows.filter(item => item.id !== row.id)
        } else {
          this.selectedRows = []
        }
      },
      changeCheckbox(checked, row) {
        if (this.selectType === 'radio') {
          return
        }
        if (checked) {
          this.addTag(row)
        } else {
          this.removeSelectedRow(row)
        }
      },
      checkAll(checked) {
        this.data.forEach(item => {
          if (checked) {
            this.addTag(item)
          } else {
            this.closeTag(item)
          }
        })
      }
    }
  }
</script>